
import { Button, Container, LinearProgress } from '@mui/material'
import { withSnackbar } from 'notistack'
import React from 'react'
import { withRouter } from "react-router-dom"
import SocketIO from '../socketio'
import StoreList from './StoreList'

class StoresWithService extends React.Component {
    socket = null

    state = {
        initialized: false,
        storeIds: [],
    }

    async componentDidMount() {
        this.socket = new SocketIO()

        this.unbindConnect = this.socket.on('connect', this.handleConnect)
    }

    componentWillUnmount() {
        this.unbindConnect()

        this.socket.disconnect()
    }

    initialFetch = async () => {
        try {
            const { serviceAbbrev } = this.props.match.params

            const { storeIds } = await this.socket.send('storesWithService', { serviceAbbrev })

            this.setState({
                initialized: true,
                storeIds,
            })
        } catch (err) {
            this.showError(err)
        }
    }

    handleConnect = () => {
        this.initialFetch()
    }

    showMessage = (msg, options) => {
        this.props.enqueueSnackbar(msg, {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            ...options,
        })
    }

    showError = (err, options) => {
        this.showMessage(err.message || err, {
            variant: 'error',
            persist: true,
            style: { whiteSpace: 'pre-line' },
            // eslint-disable-next-line react/display-name
            action: (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button>,
            ...options,
        })
    }

    closeSnackbar = this.props.closeSnackbar

    render() {
        const { initialized, storeIds } = this.state
        const { serviceAbbrev } = this.props.match.params

        if (!initialized) {
            return (
                <Container maxWidth="xs" sx={{ py: 10 }}>
                    <LinearProgress />
                </Container>
            )
        }

        return (
            <Container maxWidth="lg">
                <StoreList
                    minimalMode={true}
                    filter={(store) => storeIds.includes(store.id)}
                    urlSuffix={`/guest/book/findByAbbrev/${serviceAbbrev}`}
                />
            </Container>
        )
    }
}

export default withRouter(withSnackbar(StoresWithService))
